export default __webpack_public_path__ + "static/media/3.10bace5f.png";